import { GetterTree, ActionTree, MutationTree } from 'vuex'
import { properties, property, operations, types, filters } from '@/services/ApiMapaprop'


class State {
    operations: any[] = []
    properties: any[] = []
    propertiesCurrent: number = 0
    propertiesSize: number = 20
    propertiesFrom: number = 0
    propertiesTotal: number = 0
    propertiesWait: boolean = true
    property: any = null
    types: any[] = []
    from: any = 0
    filters: any[] = []
}

const getters: GetterTree<State, any> = {
    operations: (state) => state.operations,
    properties: (state) => state.properties,
    propertiesCurrent: (state) => state.propertiesCurrent,
    propertiesSize: (state) => state.propertiesSize,
    propertiesFrom: (state) => state.propertiesFrom,
    propertiesTotal: (state) => state.propertiesTotal,
    propertiesWait: (state) => state.propertiesWait,
    property: (state) => state.property,
    types: (state) => state.types,
    from: (state) => state.from,
    filters: (state) => state.filters
}


const mutations: MutationTree<State> = {
    operationsHandler(state, payload) {
        let result = []
        for (const [key, value] of Object.entries(payload.operations)) {
            // if (key != '1' && key != '4' && key != '5') {
            //     result.push({ key: key, value: value })
            // }
            // quitar compartir argentina
            if (key != '6') {
                result.push({ key: key, value: value })
            }
            // con esta opcion serian todas
            // result.push({ key: key, value: value })
        }
        state.operations = result
    },
    propertiesHandler(state, payload) {
        if (payload !== null) {
            const properties = payload.data.properties

            // console.group("src/store/requests/index.ts: propertiesHandler()");
            // console.log(state,payload)
            // console.groupEnd();

            let valOperation;
            let valType;

            for (let i = 0; i < payload.data.filters.length; i++) {
              if(payload.data.filters[i].operation){
                valOperation = payload.data.filters[i].operation
              }
            }

            if(valOperation != null) {
              for (let i = 0; i < state.operations.length; i++) {
                if (state.operations[i].key == valOperation.id){
                  valOperation.name = state.operations[i].value
                }
              }
            }

            for (let i = 0; i < payload.data.filters.length; i++) {
              if(payload.data.filters[i].type){
                valType = payload.data.filters[i].type
              }
            }

            if(valType != null) {
              for (let i = 0; i < state.types.length; i++) {
                if (state.types[i].key == valType.id){
                  valType.name = state.types[i].value
                }
              }
            }

            const propertiesfilter = properties.filter((elem: any) => {
                if (elem.reserved === false && elem.rented === false && elem.sold === false && elem.suspended === false) {

                    return elem
                }
            })


            state.filters = payload.data.filters
            state.propertiesCurrent = payload.current
            state.propertiesFrom = payload.current
            state.propertiesTotal = payload.data.total

            if (payload.moreData) {
                propertiesfilter.forEach((elem: any) => {
                    state.properties.push(elem)
                })
            } else {
                state.properties = propertiesfilter
            }
        } else {
            state.properties = []
            state.propertiesCurrent = 0
            state.propertiesFrom = 0
            state.propertiesTotal = 0
        }
    },
    propertiesWaitHandler(state, payload) {
        state.propertiesWait = payload
    },
    propertyHandler(state, payload) {
        // console.group('src/store/requests/index.ts: propertyHandler()')
        // console.log(state, payload)
        // console.groupEnd()
    },
    typesHandler(state, payload) {
        let result: any[] = []
        for (const [key, value] of Object.entries(payload.types)) {
            result.push({ key: key, value: value })
        }

        state.types = result
    },
    propertyFromHandler(state, payload) {
        // console.group("Mutation - propertyFromHandler()")
        // console.log(state, payload)
        // console.groupEnd()
    }
}

const actions: ActionTree<State, any> = {
    async operationsRequest({ commit }, country) {
        try {
            const { data } = await operations(country)
            commit('operationsHandler', data)
        } catch (error) {
            console.error(error)
        }
    },
    async propertiesRequest({ getters, rootGetters, commit }, payload) {
        if (getters.properties.length == 0) commit('propertiesWaitHandler', true)

        let params: any = {}
        // console.log(getters.propertiesFrom)

        if (rootGetters.params.bathrooms) params.bathrooms = rootGetters.params.bathrooms
        if (rootGetters.params.bedrooms) params.bedrooms = rootGetters.params.bedrooms
        if (rootGetters.params.buildingStatus) params.buildingStatus = rootGetters.params.buildingStatus
        if (rootGetters.params.cityId) params.cityId = rootGetters.params.cityId
        if (rootGetters.params.countyId) params.countyId = rootGetters.params.countyId
        if (rootGetters.params.dateFrom) params.dateFrom = rootGetters.params.dateFrom
        if (rootGetters.params.dateTo) params.dateTo = rootGetters.params.dateTo
        if (rootGetters.params.from) params.from = getters.propertiesFrom
        if (rootGetters.params.operation) params.operation = rootGetters.params.operation
        if (rootGetters.params.size) params.size = rootGetters.params.size
        if (rootGetters.params.stateId) params.stateId = rootGetters.params.stateId
        if (rootGetters.params.tempOccupancy) params.tempOccupancy = rootGetters.params.tempOccupancy
        if (rootGetters.params.term) params.term = rootGetters.params.term
        if (rootGetters.params.type) params.type = rootGetters.params.type
        if (rootGetters.params.priceFrom) params.priceFrom = rootGetters.params.priceFrom
        if (rootGetters.params.priceTo) params.priceTo = rootGetters.params.priceTo
        if (rootGetters.params.currency) params.currency = rootGetters.params.currency

        // console.group("propertiesRequest()")
        // console.log(params)
        // console.log(rootGetters.params.from)
        // console.groupEnd()

        const response = await properties(params)

        if (payload) {
            commit('propertiesHandler', {
                current: getters.propertiesCurrent + getters.propertiesSize,
                data: response.data,
                moreData: true
            })
        } else {
            commit('propertiesHandler', {
                current: response.data.properties.length,
                data: response.data,
                moreData: false
            })
        }

        setTimeout(() => {
            commit('propertiesWaitHandler', false)
        }, 500)
    },
    propertyRequest({ commit }, hash) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await property(hash)

                resolve({ title: data.title, description: data.description })
            } catch (error) {
                console.error(error)
            }
        })
    },
    async typesRequest({ commit }, country) {
        try {
            const { data } = await types(country)
            commit('typesHandler', data)
        } catch (error) {
            console.error(error)
        }
    },
    async filtersRequest({ getters, rootGetters, commit }, payload) {

        if (filters.length == 0) commit('filtersWaitHandler', true)

        let params: any = {}
        // console.log(getters.propertiesFrom)

        if (rootGetters.params.operationTag) params.operationTag = rootGetters.params.operationTag
          params = params.operationTag
    }
}

export default {
    namespaced: true,
    state: new State(),
    mutations,
    actions,
    getters
}
